// src/components/Muestras/DrawerColores.jsx
import React from "react";
import { Box, Typography, Drawer, TextField, Button } from "@mui/material";

const DrawerColores = ({ open, onClose, color, onChange, onSave }) => {
  if (!color) return null;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{ "& .MuiDrawer-paper": { width: 380, p: 3 } }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
        Editar color
      </Typography>

      <Box
        sx={{
          backgroundColor: color.HEX || "#ffffff",
          height: 60,
          borderRadius: 2,
          mb: 2,
          border: "1px solid rgba(0,0,0,0.2)",
        }}
      />

      {/*  <TextField
        label="Nombre"
        value={color.COLOR || ""}
        onChange={(e) => onChange({ ...color, COLOR: e.target.value })}
        fullWidth
        sx={{ mb: 2 }}
      /> */}

      <TextField
        label="Pantone"
        value={color.PANTONE || ""}
        onChange={(e) => onChange({ ...color, PANTONE: e.target.value })}
        fullWidth
        sx={{ mb: 2 }}
      />

      <TextField
        label="HEX"
        value={color.HEX || ""}
        onChange={(e) => onChange({ ...color, HEX: e.target.value })}
        fullWidth
        sx={{ mb: 2 }}
      />

      <Box display="flex" gap={2} sx={{ mb: 2 }}>
        <TextField
          label="R"
          type="number"
          value={color.RED || ""}
          onChange={(e) =>
            onChange({ ...color, RED: parseInt(e.target.value || 0) })
          }
          sx={{ flex: 1 }}
        />
        <TextField
          label="G"
          type="number"
          value={color.GREEN || ""}
          onChange={(e) =>
            onChange({ ...color, GREEN: parseInt(e.target.value || 0) })
          }
          sx={{ flex: 1 }}
        />
        <TextField
          label="B"
          type="number"
          value={color.BLUE || ""}
          onChange={(e) =>
            onChange({ ...color, BLUE: parseInt(e.target.value || 0) })
          }
          sx={{ flex: 1 }}
        />
      </Box>

      <Button variant="contained" color="primary" fullWidth onClick={onSave}>
        Guardar cambios
      </Button>
    </Drawer>
  );
};

export default DrawerColores;
